// extracted by mini-css-extract-plugin
module.exports = {"NumericOptionalRangeFeature":"kb_a pz_b pz_ro"};